import { FunctionComponent } from 'react'
import { MarkerCluster, MarkerClusterGroup as LFMarkerClusterGroup } from 'leaflet'
import { LayerGroup, Polyline, useMap } from 'react-leaflet'
import MarkerClusterGroup from 'react-leaflet-markercluster'
import { getTaskMarker } from './map-utils'
import { RouteState, RouteTaskState } from '../../enumerations/route.enumeration'

import L from 'leaflet'
import { MapRoute } from './map-types'

/**
 * Properties type for JobMapCard
 */
type RoutesLayerProps = {
  route: MapRoute
  resource?: any
  i?: number
}

export const RoutesLayer: FunctionComponent<RoutesLayerProps> = ({ route, resource, i }) => {
  const map = useMap()

  const getRouteDashArray = () => {
    if (route.state === RouteState.CANCELLED) {
      return '5 8'
    }
  }

  const getRouteColor = () => {
    if (route.state === RouteState.CANCELLED) {
      return 'black'
    }
    return route.color.base
  }

  const clusterCreateIcon = () => {
    const color = route.color.name

    map.eachLayer((ly) => {
      if (ly && ly.hasOwnProperty('refreshClusters')) {
        const markerClusterLy = ly as LFMarkerClusterGroup
        markerClusterLy.refreshClusters()
      }
    })

    return (cluster: MarkerCluster) => {
      const childCount = cluster.getChildCount()
      return new L.DivIcon({
        html: `<div><span>${childCount}</span></div>`,
        className: `marker-cluster marker-cluster-${color} mate`,
        iconSize: new L.Point(30, 30)
      })
    }
  }

  return (
    <LayerGroup key={`${route.id ? route.id : i}`}>
      <Polyline
        color={getRouteColor()}
        dashArray={getRouteDashArray()}
        positions={route.points.map((p: any) => p.location)}
      />
      <MarkerClusterGroup
        iconCreateFunction={clusterCreateIcon()}
        polygonOptions={{ color: route.color.base, fill: route.color.mate }}
      >
        {route.points.map((point, j) => {
          if (j !== 0 && j < route.points.length - 1) {
            let styles = `border: 1px solid #A0A1A2; background: ${route.color.base}; color: white;`

            if (route.state === RouteState.CANCELLED) {
              styles = `border: 1px solid #727374; background: white; color: #727374;`
            } else if (point.state === RouteTaskState.CANCELED || point.state === RouteTaskState.RESET) {
              styles = `border: 1px solid ${route.color.base}; background: white; color: ${route.color.base};`
            }
            return getTaskMarker(j, point.location, styles)
          }

          return null
        })}
      </MarkerClusterGroup>
      {resource}
    </LayerGroup>
  )
}
